// What a value the owner does not share with this viewer shows: a lock and "Private", on the
// profile's Profit card and the leaderboard's profit cells alike.

import { Lock } from 'lucide-react';
import type { ReactElement } from 'react';

interface PrivateValueProps {
  /** Layout for where it sits, such as a margin or the row's alignment. */
  className?: string;
}

export function PrivateValue({ className = '' }: PrivateValueProps): ReactElement {
  return (
    <div className={`flex items-center gap-1 text-theme-text-tertiary ${className}`}>
      <Lock className="w-3.5 h-3.5 shrink-0" aria-hidden="true" />
      <span className="text-sm font-medium">Private</span>
    </div>
  );
}
